export enum AdobeMethods {
    PAGE_LOAD = 'pageLoad',
    TRACK_ACTION = 'trackAction',
    TRACK_PROCESS = 'trackProcess',
    SUB_PAGE_VIEWED = 'subPageViewed',
}
